import { kebabCase } from 'lodash';

export default (path: string) => `var(--${kebabCase(path)})`;
